<template>
  <div class="base_mark_content">
    <div class="mark">
      <div>
        <img width="60px" height="60px" :src="markData.icon" alt="">
      </div>

      <div class="top">
        <div class="mark_score">
          <div v-if="markShow" @mouseover="markOverHandler" @mouseout="markOutHandler">{{markData.score}}</div>
        </div>
        <div class="mark_content company_mark_content animated" :class="{'bounceInUp': !markShow}">
          <div v-if="!markShow" @mouseout="markContentOutHandler" @mouseover="markContentOverHandler">
            <div class="mark_content_top">
              <div class="company_name">{{markData.company_name}}</div>
              <div class="company_info">
                <span class="score">评分<span class="value">{{markData.score}}</span></span>
                <span class="sort">排名<span class="value">{{markData.sort}}</span></span>
              </div>
            </div>
            <div class="mark_content_bottom">
              <div class="suggest" v-for="(item, index) in markData.suggest" :key="index">{{item}}</div>
            </div>
          </div>

        </div>
      </div>

      <div class="line"></div>
    </div>
  </div>
</template>

<script>
  import baseInfoWindow from './base_info_window'
  import { mapState } from 'vuex'
  export default {
    name: "base_mark_content",
    data() {
      return {
        markData: {},
        markShow: true,
        pitch: 0
      }
    },
    computed: {
      ...mapState(['AMapData'])
    },
    components: {
      baseInfoWindow
    },
    created() {
    },
    mounted() {
    },
    methods: {
      markOverHandler(){
        this.markShow = false;
      },
      markOutHandler(){
        this.markShow = true;
      },
      markContentOutHandler(){
        this.markShow = true;
      },
      markContentOverHandler(){
        this.markShow = false;
      }
    },
    watch: {

    }
  }
</script>

<style lang="less" scoped>
.base_mark_content{
  /*transform: rotateY(50deg);*/
  position: relative;
  .mark{
    position: absolute;
    .top{
      position: absolute;
      bottom: 230px;
      left: 0;
      right: 0;
      margin: auto;
      /*width: 50px;*/
      /*height: 50px;*/
      color: #ffffff;
      font-size: 20px;
      text-align: center;
      line-height: 50px;
    }
    .line{
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      margin: auto;

      height: 200px;
      width: 1px;
      background: linear-gradient(bottom, rgba(20,230,198, 0.2), rgba(20,230,198, 1));
    }
  }

  .mark_score{
    width: 50px;
    height: 50px;
    div{
      border-radius: 50%;
      width: 50px;
      height: 50px;
      background: #42bffe;
    }
  }

  .mark_content{
    position: absolute;
    bottom: 0;
    left: -125px;
    z-index: 10000;
    margin: auto;
    background: rgba(0,0,0,0.8);
    text-align: center;

    border-radius: 5px;

    /*line-height: 1;*/


  }

  .company_mark_content{
    /*display: none;*/
    text-align: left;
    width: 300px;
    &>div{
      padding: 5px 15px;
      border: 1px solid rgba(0,0,0,0.2);
      box-shadow: 0 0 5px rgba(0,0,0,0.5);
    }

    .mark_content_top{
      color: #ffffff;

      border-bottom: 1px dashed #9ea0ab;
      padding-bottom: 5px;
      margin-bottom: 5px;
      padding-top: 5px;
      font-size: 14px;
      .company_name{

      }
      .company_info{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .value{
          color: #42bffe;
        }
        .score{

        }
        .sort{

        }
      }
    }
    .mark_content_bottom{
      color: #42bffe;
      line-height: 25px;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/base_mark_content.vue